import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { isEmptyOrSpaces } from '../Utilities/Helpers/DataValidity.Helper';
import { NavigateApi } from './Models/NavigateApi';

export type PropsPassedWrappedComponent = {
  params: URLSearchParams;
  navigateApi: NavigateApi;
};

export const UIClaimsUnAuthRenderer = (WrappedComponent: React.ElementType) => {
  return function DebugDetailsWrapper() {
    const [params] = useSearchParams();
    const navigate = useNavigate();

    const navigateTo = (src: string) => {
      if (src && !isEmptyOrSpaces(src)) {
        navigate(src, { replace: true });
      }
    };

    const navigateApi: NavigateApi = {
      navigateTo,
    };

    const props: PropsPassedWrappedComponent = {
      params: params,
      navigateApi: navigateApi,
    };

    const wrappedComponent = (
      <>
        <WrappedComponent {...props}></WrappedComponent>
      </>
    );

    return <>{wrappedComponent}</>;
  };
};
